export const validatePaymentLinkForm = (values) => {
  const errors = {};

  if (!values.selectedGym) {
    errors.selectedGym = "Please select a gym";
  }

  if (!values.selectedPlanType) {
    errors.selectedPlanType = "Please select a plan type";
  }

  if (values.selectedPlanType?.value === "regular" && !values.selSourceName) {
    errors.selSourceName = "Please select a plan type";
  }

  if (
    values.selectedPlanType &&
    values.selectedPlanType?.value === "regular" &&
    !values.selectedPlan
  ) {
    errors.selectedPlan = "Please select a plan";
  }

  if (
    values.selectedPlanType &&
    values.selectedPlanType?.value === "addon" &&
    !values.selectedAddon
  ) {
    errors.selectedAddon = "Please select addon";
  }

  if (
    values.selectedPlanType &&
    values.selectedPlanType?.value === "addon" &&
    !values.selectedSlotDate
  ) {
    errors.selectedSlotDate = "Please select slot date";
  }

  if (
    values.selectedPlanType &&
    values.selectedPlanType?.value === "addon" &&
    !values.selectedTrainer
  ) {
    errors.selectedTrainer = "Please select trainer";
  }

  // if (
  //   values.selectedPlanType &&
  //   values.selectedPlanType?.value === "addon" &&
  //   !values.selectedSlotStartTime &&
  //   !values.selectedSlotEndTime
  // ) {
  //   errors.selectedSlot = "Please select slot";
  // }

  // if (
  //   values.selectedPlanType &&
  //   values.selectedPlanType?.value === "addon" &&
  //   values.selectedAddon &&
  //   values.selectedSlotDate &&
  //   !values.selectedSlot
  // ) {
  //   errors.selectedSlot = "Please select slot";
  // }

  if (
    values.selectedPlanType &&
    values.selectedPlanType?.value === "addon" &&
    values.selectedAddon &&
    !values.selectedSession
  ) {
    errors.selectedSession = "Please select session";
  }

  if (!values.selectedSubsStartDate) {
    errors.selectedSubsStartDate = "Please select a start date";
  }

  if (!values.selectedPrice) {
    errors.selectedPrice = "Please select a price";
  }

  if (!values.isWhatsapp && !values.selectedWhatsapNo) {
    errors.selectedWhatsapNo = "Please enter whatsapp number";
  } else if (
    values.selectedWhatsapNo &&
    values.selectedWhatsapNo?.length !== 10
  ) {
    errors.selectedWhatsapNo = "Please enter a valid alternate/whatsapp number";
  }

  if (!values.paymentMode) {
    errors.paymentMode = "Please select a payment type";
  }

  // if (
  //   values.paymentMode &&
  //   values.paymentMode?.value !== "cash" &&
  //   !values.description
  // ) {
  //   errors.description = "Please enter description";
  // }

  if (
    values.paymentMode &&
    values.paymentMode?.value === "partial" &&
    !values.partialCash
  ) {
    errors.partialCash = "Please enter cash amount";
  }

  if (
    values.paymentMode &&
    values.paymentMode?.value === "partial" &&
    !values.partialOnline
  ) {
    errors.partialOnline = "Please enter online amount";
  }

  if (
    values.paymentMode &&
    values.paymentMode?.value === "partial" &&
    values.partialOnline &&
    values.partialCash &&
    values.selectedPrice &&
    parseFloat(values.selectedPrice?.label) !==
      parseFloat(values.partialCash) + parseFloat(values.partialOnline)
  ) {
    errors.partialCash = "Cash and Online Amount Must be equal to Price";
    errors.partialOnline = "Cash and Online Amount Must be equal to Price";
  }

  return errors;
};

export const validatemap_form_email = (email) => {
  let regex =
    /^[a-zA-Z0-9]+(?:[._%+-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$/;
  let errors = {};
  let validate = true;

  if (!email) {
    errors.message = "*Email is mandatary";
    validate = false;
  } else if (!regex.test(email)) {
    errors.message = "*Email is Invalid";
    validate = false;
  } else if (email.includes("yopmail.com")) {
    errors.message = "*Yopmail is not accepted!";
    validate = false;
  }

  return validate;
};

export const validatePartialPaymentForm = (values) => {
  const errors = {};

  if (!values.selectedGym) {
    errors.selectedGym = "Please select a gym";
  }

  if (!values.selectedPlanType) {
    errors.selectedPlanType = "Please select a plan type";
  }

  if (values.selectedPlanType?.value === "regular" && !values.selSourceName) {
    errors.selSourceName = "Please select a source name";
  }

  if (
    values.selectedPlanType &&
    values.selectedPlanType?.value === "regular" &&
    !values.selectedPlan
  ) {
    errors.selectedPlan = "Please select a plan";
  }

  if (
    values.selectedPlanType &&
    // values.selectedPlanType?.value === "addon"
    (values.selectedPlanType?.value === "addon" ||
      values.selectedPlanType?.value === "addon_pt") &&
    !values.selectedAddon
  ) {
    errors.selectedAddon = "Please select addon";
  }

  if (
    values.selectedPlanType &&
    // values.selectedPlanType?.value === "addon"
    (values.selectedPlanType?.value === "addon" ||
      values.selectedPlanType?.value === "addon_pt") &&
    !values.selectedSlotDate
  ) {
    errors.selectedSlotDate = "Please select slot date";
  }

  if (
    values.selectedPlanType &&
    // values.selectedPlanType?.value === "addon"
    (values.selectedPlanType?.value === "addon" ||
      values.selectedPlanType?.value === "addon_pt") &&
    !values.selectedTrainer
  ) {
    errors.selectedTrainer = "Please select trainer";
  }

  if (
    values.selectedPlanType &&
    // values.selectedPlanType?.value === "addon"
    (values.selectedPlanType?.value === "addon" ||
      values.selectedPlanType?.value === "addon_pt") &&
    values.selectedAddon &&
    !values.selectedSession
  ) {
    errors.selectedSession = "Please select session";
  }

  if (!values.selectedSubsStartDate) {
    errors.selectedSubsStartDate = "Please select a start date";
  }

  if (!values.selectedPrice) {
    errors.selectedPrice = "Please select a price";
  }

  if (!values.isWhatsapp && !values.selectedWhatsapNo) {
    errors.selectedWhatsapNo = "Please enter whatsapp number";
  } else if (
    values.selectedWhatsapNo &&
    values.selectedWhatsapNo?.length !== 10
  ) {
    errors.selectedWhatsapNo = "Please enter a valid alternate/whatsapp number";
  }

  if (!values.paymentMode) {
    errors.paymentMode = "Please select first payment type";
  }

  if (!values.firInsDate) {
    errors.firInsDate = "Please first installment date";
  }

  if (!values.secInsDate) {
    errors.secInsDate = "Please second installment date";
  }

  if (!values.thiInsDate) {
    errors.thiInsDate = "Please third installment date";
  }

  if (!values.firInsAmount) {
    errors.firInsAmount = "Please first installment amount";
  }

  if (!values.secInsAmount) {
    errors.secInsAmount = "Please second installment amount";
  }

  if (!values.thiInsAmount) {
    errors.thiInsAmount = "Please third installment amount";
  }

  const sumOfInstallments = parseInt(
    parseInt(values.firInsAmount || 0) +
      parseInt(values.secInsAmount || 0) +
      parseInt(values.thiInsAmount || 0)
  );

  if (
    (values.selectedPrice?.label && parseInt(values.selectedPrice.label)) !==
    sumOfInstallments
  ) {
    errors.selectedPrice = "Installment should be equal to selected price";
    errors.firInsAmount = "Installment should be equal to selected price";
    errors.secInsAmount = "Installment should be equal to selected price";
    errors.thiInsAmount = "Installment should be equal to selected price";
  }

  return errors;
};

export const validationOfferForm = (formValues) => {
  let errors = {};

  if (!formValues.offerName) {
    errors.offerName = "required!";
  }

  if (!formValues.offerCode) {
    errors.offerCode = "required!";
  }

  if (!formValues.offerMode) {
    errors.offerMode = "required!";
  }

  if (!formValues.offerValidity) {
    errors.offerValidity = "required!";
  }

  if (!formValues.offerPlanType) {
    errors.offerPlanType = "required!";
  }

  if (!formValues.offerType) {
    errors.offerType = "required!";
  }

  return errors;
};
